import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./HomePage.scss";
import { getAllCategory } from "../../api/category";
import { getProducts } from "../../api/products";
import { addToCart as addToCartApi, getCart } from "../../api/cart";
import {
  addToCartList,
  clearCart as clearCartItems,
} from "../../store/reducers/cartReducer";
import { normalizeApiCartItem } from "./cartUtils";
import { useHistory } from "react-router-dom";
import {HeaderAdvertisement, HeaderFilter, HeaderMasterTemplate, TopDeal} from '../template';
// ── SVG Icons ─────────────────────────────────────────────
const Icons = {
  Search: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.35-4.35" />
    </svg>
  ),
  User: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Heart: ({ filled }) => (
    <svg
      viewBox="0 0 24 24"
      fill={filled ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </svg>
  ),
  Cart: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="9" cy="21" r="1" />
      <circle cx="20" cy="21" r="1" />
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
    </svg>
  ),
  Home: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
  Cpu: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <rect x="9" y="9" width="6" height="6" />
      <path d="M9 1v3M15 1v3M9 20v3M15 20v3M1 9h3M1 15h3M20 9h3M20 15h3" />
    </svg>
  ),
  Shirt: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.57a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.57a2 2 0 0 0-1.34-2.23z" />
    </svg>
  ),
  Watch: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="6" />
      <polyline points="12 10 12 12 13 13" />
      <path d="m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05M7.88 16.36l.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05" />
    </svg>
  ),
  Tag: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
  ),
  Sparkle: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 3v1m0 16v1M4.22 4.22l.7.7m12.16 12.16.7.7M3 12h1m16 0h1M4.22 19.78l.7-.7M18.36 5.64l.7-.7" />
      <circle cx="12" cy="12" r="4" />
    </svg>
  ),
  Star2: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
  Star: () => (
    <svg viewBox="0 0 24 24" fill="currentColor" stroke="none">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
  ShoppingCart: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="9" cy="21" r="1" />
      <circle cx="20" cy="21" r="1" />
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
    </svg>
  ),
  ChevronRight: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="9 18 15 12 9 6" />
    </svg>
  ),
  ChevronUp: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="18 15 12 9 6 15" />
    </svg>
  ),
  Truck: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="1" y="3" width="15" height="13" />
      <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
      <circle cx="5.5" cy="18.5" r="2.5" />
      <circle cx="18.5" cy="18.5" r="2.5" />
    </svg>
  ),
  RefreshCw: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="23 4 23 10 17 10" />
      <polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </svg>
  ),
  Shield: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  Headphones: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
      <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
    </svg>
  ),
  Mail: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  ),
  Apple: () => (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
    </svg>
  ),
  PlayStore: () => (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M3 20.5v-17c0-.83.94-1.3 1.6-.8l14 8.5c.6.36.6 1.24 0 1.6l-14 8.5c-.66.5-1.6.03-1.6-.8z" />
    </svg>
  ),
};

// ── Data ───────────────────────────────────────────────────
const TOP_DEALS = [
  {
    id: 1,
    name: "Bose QuietComfort 45 Wireless Headphones",
    price: 279,
    original: 349,
    rating: 4.6,
    disc: -20,
    img: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=200&q=80",
  },
  {
    id: 2,
    name: "Apple Watch Series 9 GPS 41mm",
    price: 339,
    original: 399,
    rating: 4.7,
    disc: -15,
    img: "https://images.unsplash.com/photo-1546868871-7041f2a55e12?w=200&q=80",
  },
  {
    id: 3,
    name: "Nike Air Max 270 Men's Shoes",
    price: 104,
    original: 139,
    rating: 4.6,
    disc: -25,
    img: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=200&q=80",
  },
  {
    id: 4,
    name: "Apple AirPods Pro 2 Wireless Earbuds",
    price: 199,
    original: 249,
    rating: 4.7,
    disc: -20,
    img: "https://images.unsplash.com/photo-1590658268037-6bf12165a8df?w=200&q=80",
  },
  {
    id: 5,
    name: "Ray-Ban Wayfarer Sunglasses",
    price: 114,
    original: 139,
    rating: 4.6,
    disc: -18,
    img: "https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=200&q=80",
  },
];

const BEST_SELLERS = [
  {
    id: 1,
    name: "Sony QuietComfort 5 Wireless Headphones",
    sub: "",
    price: 349,
    rating: 4.8,
    img: "https://images.unsplash.com/photo-1484704849700-f032a568e944?w=200&q=80",
  },
  {
    id: 2,
    name: "Apple Watch Series 9 GPS 41mm",
    sub: "",
    price: 339,
    rating: 4.7,
    img: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=200&q=80",
  },
  {
    id: 3,
    name: "Fossil Chronograph Watch",
    sub: "",
    price: 159,
    rating: 4.6,
    img: "https://images.unsplash.com/photo-1523170335258-f5ed11844a49?w=200&q=80",
  },
  {
    id: 4,
    name: "Premium Hoodie",
    sub: "Men, Beige, Size L",
    price: 59,
    rating: 4.5,
    img: "https://images.unsplash.com/photo-1556821840-3a63f15732ce?w=200&q=80",
  },
  {
    id: 5,
    name: "Ray-Ban Wayfarer Sunglasses",
    sub: "",
    price: 139,
    rating: 4.6,
    img: "https://images.unsplash.com/photo-1473496169904-658ba7574b0d?w=200&q=80",
  },
];

const NEW_ARRIVALS = [
  {
    id: 1,
    name: "iPhone 15 Pro Max",
    sub: "256GB",
    price: 1199,
    rating: 4.8,
    img: "https://images.unsplash.com/photo-1678685888221-cda773a3dcdb?w=200&q=80",
  },
  {
    id: 2,
    name: "MacBook Air M2",
    sub: "13-inch",
    price: 999,
    rating: 4.7,
    img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=200&q=80",
  },
  {
    id: 3,
    name: "JBL Charge 5 Bluetooth Speaker",
    sub: "",
    price: 179,
    rating: 4.6,
    img: "https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=200&q=80",
  },
  {
    id: 4,
    name: "Nike Heritage Backpack",
    sub: "25L",
    price: 59,
    rating: 4.5,
    img: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=200&q=80",
  },
  {
    id: 5,
    name: "Adidas Sport Cap",
    sub: "Unisex",
    price: 24,
    rating: 4.6,
    img: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=200&q=80",
  },
];

// ── Sub-Components ─────────────────────────────────────────
function StarRow({ rating }) {
  return (
    <div className="ome__product-rating">
      <div className="stars">
        {[1, 2, 3, 4, 5].map((n) => (
          <Icons.Star
            key={n}
            style={{ opacity: n <= Math.round(rating) ? 1 : 0.2 }}
          />
        ))}
      </div>
      <span>{rating}</span>
    </div>
  );
}

function ProductCard({ product, showDisc, isNew }) {
  const [liked, setLiked] = useState(false);
  const dispatch = useDispatch();

  const handleAddToCart = async () => {
    dispatch(
      addToCartList({
        id: product.id,
        name: product.name,
        subtitle: product.brand,
        price: product.price,
        img: product.img,
        inStock: product.inStock,
      }),
    );

    try {
      await addToCartApi({ product_id: product.id, quantity: 1 });
    } catch (error) {
      console.error("Cart sync failed:", error);
    }
  };

  return (
    <div className="ome__product-card">
      <div className="ome__product-img">
        {showDisc && (
          <span className="ome__product-badge">{product.disc}%</span>
        )}
        {isNew && <span className="ome__product-new-badge">New</span>}
        <button
          className={`ome__product-fav${liked ? " liked" : ""}`}
          onClick={() => setLiked((v) => !v)}
        >
          <Icons.Heart filled={liked} />
        </button>
        <img src={product.img} alt={product.name} loading="lazy" />
      </div>
      <div className="ome__product-body">
        <div className="ome__product-name">{product.name}</div>
        {product.sub && <div className="ome__product-sub">{product.sub}</div>}
        <div className="ome__product-pricing">
          <span className="price">
            ${Number(product.price).toLocaleString()}.00
          </span>
          {product.original && (
            <span className="original">
              ${Number(product.original).toLocaleString()}.00
            </span>
          )}
        </div>
        <StarRow rating={product.rating} />
        <button className="ome__add-cart" onClick={handleAddToCart}>
          <Icons.ShoppingCart /> Add to Cart
        </button>
      </div>
    </div>
  );
}

function SectionHeader({ title, href = "#" }) {
  return (
    <div className="ome__section-header">
      <h2>{title}</h2>
      <a href={href}>
        View All <Icons.ChevronRight />
      </a>
    </div>
  );
}

const SUBCATS = [
  {
    key: "smartphones",
    label: "Smartphones",
    items: 340,
    cls: "smartphones",
    img: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=160&q=80",
  },
  {
    key: "laptops",
    label: "Laptops",
    items: 220,
    cls: "laptops",
    img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=160&q=80",
  },
  {
    key: "accessories",
    label: "Accessories",
    items: 285,
    cls: "accessories",
    img: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=160&q=80",
  },
];

const FALLBACK_PRODUCTS = [
  {
    id: 1,
    name: "Apple iPhone 14 Pro Max 256GB Deep Purple",
    price: 999,
    rating: 4.8,
    reviews: 320,
    img: "https://images.unsplash.com/photo-1678685888221-cda773a3dcdb?w=220&q=80",
  },
  {
    id: 2,
    name: "Sony WH-1000XM5 Wireless Headphones",
    price: 349,
    rating: 4.7,
    reviews: 180,
    img: "https://images.unsplash.com/photo-1484704849700-f032a568e944?w=220&q=80",
  },
  {
    id: 3,
    name: "Apple Watch Series 9 GPS 41mm",
    price: 399,
    rating: 4.7,
    reviews: 210,
    img: "https://images.unsplash.com/photo-1546868871-7041f2a55e12?w=220&q=80",
  },
  {
    id: 4,
    name: "Apple AirPods Pro (2nd Generation)",
    price: 249,
    rating: 4.8,
    reviews: 380,
    img: "https://images.unsplash.com/photo-1590658268037-6bf12165a8df?w=220&q=80",
  },
  {
    id: 5,
    name: "Sony Alpha a7 IV Mirrorless Camera",
    price: 1899,
    rating: 4.6,
    reviews: 98,
    img: "https://images.unsplash.com/photo-1516035069371-29a1b244cc32?w=220&q=80",
  },
  {
    id: 6,
    name: "Apple MacBook Air M2 13-inch 256GB",
    price: 1099,
    rating: 4.8,
    reviews: 160,
    img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=220&q=80",
  },
  {
    id: 7,
    name: "JBL Charge 5 Portable Bluetooth Speaker",
    price: 179,
    rating: 4.6,
    reviews: 310,
    img: "https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=220&q=80",
  },
  {
    id: 8,
    name: "Samsung Galaxy S23 Ultra 256GB",
    price: 1199,
    rating: 4.7,
    reviews: 220,
    img: "https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?w=220&q=80",
  },
];

const isSameId = (firstId, secondId) =>
  firstId != null && secondId != null && String(firstId) === String(secondId);

const getCategoryId = (category) =>
  category?.category_id ?? category?.id ?? category?._id;

const getCategoryName = (category) =>
  category?.category_name ?? category?.name ?? "Category";

const getCategoryImage = (category, fallback) =>
  category?.image_url ??
  category?.image ??
  category?.thumbnail ??
  category?.category_image ??
  fallback;

const getSubCategoryId = (subCategory) =>
  subCategory?.sub_category_id ??
  subCategory?.subcategory_id ??
  subCategory?.id;

const getSubCategoryName = (subCategory) =>
  subCategory?.sub_category_name ??
  subCategory?.subcategory_name ??
  subCategory?.name ??
  "Sub Category";

const getSubCategoryImage = (subCategory, fallback) =>
  subCategory?.image_url ??
  subCategory?.image ??
  subCategory?.thumbnail ??
  subCategory?.sub_category_image ??
  fallback;

const getSubCategories = (category) =>
  Array.isArray(category?.sub_category)
    ? category.sub_category
    : Array.isArray(category?.sub_categories)
      ? category.sub_categories
      : [];

const getProductList = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.products)) return response.products;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.data?.products)) return response.data.products;
  if (Array.isArray(response?.data?.data)) return response.data.data;
  return [];
};

const getProductImage = (product, fallback) => {
  const images = product?.images || product?.product_images;
  if (Array.isArray(images) && images.length > 0) {
    const firstImage = images[0];
    return firstImage?.url || firstImage?.image_url || firstImage;
  }

  return (
    product?.img ||
    product?.image ||
    product?.image_url ||
    product?.thumbnail ||
    fallback
  );
};

const getProductCategoryId = (product) =>
  product?.category_id ??
  product?.category?.category_id ??
  product?.category?.id ??
  product?.category?._id;

const getProductSubCategoryId = (product) =>
  product?.sub_category_id ??
  product?.subcategory_id ??
  product?.subCategoryId ??
  product?.sub_category?.sub_category_id ??
  product?.sub_category?.id ??
  product?.sub_category?._id;

const getProductBrand = (product) =>
  product?.brand ??
  product?.brand_name ??
  product?.vendor?.vendor_name ??
  product?.vendor?.store_company_name ??
  product?.vendor_name;

const getProductStockStatus = (product) => {
  if (product?.in_stock != null) return Boolean(product.in_stock);
  if (product?.stock_status) return product.stock_status === "in_stock";
  const stockQuantity = product?.inventory?.quantity ?? product?.quantity;
  if (stockQuantity != null) return Number(stockQuantity) > 0;
  return true;
};

const normalizeProduct = (product, index) => ({
  id: product?.product_id ?? product?.id ?? product?._id ?? index,
  name: product?.product_name ?? product?.name ?? product?.title ?? "Product",
  price:
    product?.sale_price ??
    product?.selling_price ??
    product?.price ??
    product?.pricing?.sale_price ??
    product?.pricing?.price ??
    0,
  rating: product?.rating ?? product?.average_rating ?? 0,
  reviews: product?.reviews ?? product?.review_count ?? 0,
  categoryId: getProductCategoryId(product),
  subCategoryId: getProductSubCategoryId(product),
  brand: getProductBrand(product),
  inStock: getProductStockStatus(product),
  createdAt: product?.created_at ?? product?.createdAt ?? product?.date,
  salesCount: product?.sales_count ?? product?.sold_count ?? product?.sold ?? 0,
  discount:
    product?.discount ??
    product?.discount_percentage ??
    product?.pricing?.discount ??
    0,
  freeShipping: Boolean(product?.free_shipping ?? product?.freeShipping),
  img: getProductImage(
    product,
    FALLBACK_PRODUCTS[index % FALLBACK_PRODUCTS.length]?.img,
  ),
});

// ── Main Component ─────────────────────────────────────────
export default function HomePage() {
  const history = useHistory();
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.CartReducer?.items || []);
  const [heroDot, setHeroDot] = useState(0);
  const [email, setEmail] = useState("");
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [activeCatId, setActiveCatId] = useState(null);
  const [activeSubCatId, setActiveSubCatId] = useState(null);
  const [products, setProducts] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const [activeTab, setActiveTab] = useState("All");
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("newest");
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [avail, setAvail] = useState({ inStock: true, outStock: false });

  const handleCategorySelect = (category) => {
    const nextCategoryId = getCategoryId(category);
    setActiveCatId(nextCategoryId);
    setActiveSubCatId(null);
    setSubCategories(getSubCategories(category));
    setSelectedBrands([]);
    setSearchTerm("");
    setPage(1);
  };

  const toggleBrand = (brand) =>
    setSelectedBrands((prev) =>
      prev.includes(brand)
        ? prev.filter((item) => item !== brand)
        : [...prev, brand],
    );

  const resetFilters = () => {
    const firstCategory = categories[0];
    if (firstCategory) handleCategorySelect(firstCategory);
    setSelectedBrands([]);
    setAvail({ inStock: true, outStock: false });
    setActiveTab("All");
    setSearchTerm("");
    setSortBy("newest");
  };

  const activeCategory =
    categories.find((category) =>
      isSameId(getCategoryId(category), activeCatId),
    ) ?? categories[0];
  const activeCategoryName = getCategoryName(activeCategory);
  const activeCategoryImage = getCategoryImage(activeCategory, SUBCATS[0]?.img);

  const categoryProducts = activeCatId
    ? products.filter((product) => isSameId(product.categoryId, activeCatId))
    : products;

  const brandOptions = Object.values(
    categoryProducts.reduce((acc, product) => {
      if (!product.brand) return acc;
      const key = product.brand;
      acc[key] = acc[key] || { label: key, count: 0 };
      acc[key].count += 1;
      return acc;
    }, {}),
  );
  const brands = brandOptions;

  const tabProducts = categoryProducts.filter((product) => {
    if (activeTab === "Best Sellers") return Number(product.salesCount) > 0;
    if (activeTab === "New Arrivals") return Boolean(product.createdAt);
    if (activeTab === "Deals") return Number(product.discount) > 0;
    if (activeTab === "Top Rated") return Number(product.rating) >= 4;
    if (activeTab === "Free Shipping") return product.freeShipping;
    return true;
  });

  const visibleProducts = tabProducts.filter((product) => {
    const matchesSubCategory =
      !activeSubCatId || isSameId(product.subCategoryId, activeSubCatId);
    const matchesBrand =
      selectedBrands.length === 0 || selectedBrands.includes(product.brand);
    const matchesAvailability =
      (avail.inStock && product.inStock) ||
      (avail.outStock && !product.inStock);
    const searchableText = [product.name, product.brand]
      .filter(Boolean)
      .join(" ");
    const matchesSearch =
      !searchTerm ||
      searchableText.toLowerCase().includes(searchTerm.trim().toLowerCase());

    return (
      matchesSubCategory && matchesBrand && matchesAvailability && matchesSearch
    );
  });

  const categoryCount = categoryProducts.length;
  const inStockCount = categoryProducts.filter(
    (product) => product.inStock,
  ).length;
  const outStockCount = Math.max(categoryProducts.length - inStockCount, 0);
  const sortedProducts = [...visibleProducts].sort((first, second) => {
    if (sortBy === "price-asc")
      return Number(first.price) - Number(second.price);
    if (sortBy === "price-desc")
      return Number(second.price) - Number(first.price);
    if (sortBy === "rating")
      return Number(second.rating) - Number(first.rating);

    return new Date(second.createdAt || 0) - new Date(first.createdAt || 0);
  });
  const visibleCount = sortedProducts.length;
  const pageSize = 8;
  const totalPages = Math.max(1, Math.ceil(visibleCount / pageSize));
  const currentPage = Math.min(page, totalPages);
  const pages = Array.from(
    { length: totalPages },
    (_, index) => index + 1,
  ).slice(0, 5);
  const displayedProducts = sortedProducts.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize,
  );
  const subCategoryCards = subCategories.map((subCategory, index) => {
    const subCategoryId = getSubCategoryId(subCategory);
    return {
      id: subCategoryId,
      label: getSubCategoryName(subCategory),
      items: categoryProducts.filter((product) =>
        isSameId(product.subCategoryId, subCategoryId),
      ).length,
      cls: SUBCATS[index % SUBCATS.length]?.cls ?? "smartphones",
      img: getSubCategoryImage(
        subCategory,
        SUBCATS[index % SUBCATS.length]?.img,
      ),
    };
  });

  const getAllCategories = async () => {
    try {
      const response = await getAllCategory();
      const dbCategories = response?.data?.categories || [];
      if (response?.data?.status && dbCategories.length > 0) {
        const firstCategory = dbCategories[0];
        setCategories(dbCategories);
        handleCategorySelect(firstCategory);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoadingCategories(false);
    }
  };

  const getAllProducts = async () => {
    try {
      const response = await getProducts(1, 1000);
      setProducts(getProductList(response).map(normalizeProduct));
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoadingProducts(false);
    }
  };

  useEffect(() => {
    getAllCategories();
    getAllProducts();
  }, []);

  useEffect(() => {
    const syncCartFromApi = async () => {
      try {
        const response = await getCart();
        const apiItems = response?.data?.cart?.items ?? [];
        const normalizedItems = apiItems.map(normalizeApiCartItem);

        if (normalizedItems.length > 0) {
          dispatch(clearCartItems());
          normalizedItems.forEach((item) => {
            dispatch(addToCartList(item));
          });
        }
      } catch (error) {
        console.error("Failed to sync cart:", error);
      }
    };

    syncCartFromApi();
  }, [dispatch]);

  const cartCount = cartItems.reduce(
    (sum, item) => sum + Number(item.qty || 0),
    0,
  );

  return (
    <div className="ome">
      {/* Topbar */}
      {/* Topbar */}
      <HeaderAdvertisement/>
      {/* Nav */}
      {/*<HeaderMasterTemplate/>*/}
      {/* Nav */}
      <nav className="ome__nav">
        <div className="ome__nav-inner container">
          <div className="ome__logo">Ome</div>
          <div className="ome__search">
            <Icons.Search />
            <input
                type="text"
                placeholder="Search for products, brands and more..."
            />
          </div>
          <div className="ome__nav-actions">
            <button className="ome__nav-action">
              <Icons.User /> Account
            </button>
            <button className="ome__nav-action">
              <Icons.Heart /> Wishlist
            </button>
            <button
                className="ome__nav-action"
                onClick={() => history.push("/cart")}
            >
              <Icons.Cart />
              {cartCount > 0 && <span className="count">{cartCount}</span>} Cart
            </button>
          </div>
        </div>
      </nav>
      <HeaderFilter/>



      {/* Layout */}
      <div className="ome__layout">
        {/* Main */}
        <main className="ome__main">
          {/* Hero */}
          {/*<div className="ome__hero">*/}
          {/*  /!*<div className="ome__hero-content">*!/*/}
          {/*  /!*  <span className="eyebrow">Summer Sale</span>*!/*/}
          {/*  /!*  <h1>*!/*/}
          {/*  /!*    Discover Everything*!/*/}
          {/*  /!*    <br />*!/*/}
          {/*  /!*    You Need*!/*/}
          {/*  /!*  </h1>*!/*/}
          {/*  /!*  <p>Top brands. Best prices. Fast delivery.</p>*!/*/}
          {/*  /!*  <button className="ome__hero-cta">*!/*/}
          {/*  /!*    Shop Now <Icons.ChevronRight />*!/*/}
          {/*  /!*  </button>*!/*/}
          {/*  /!*</div>*!/*/}
          {/*  <div className="ome__hero-images">*/}
          {/*    <img*/}
          {/*      src="https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=500&q=80"*/}
          {/*      alt="Hero products"*/}
          {/*    />*/}
          {/*  </div>*/}
          {/*  <div className="ome__hero-dots">*/}
          {/*    {[0, 1, 2, 3].map((i) => (*/}
          {/*      <button*/}
          {/*        key={i}*/}
          {/*        className={`ome__hero-dot${heroDot === i ? " active" : ""}`}*/}
          {/*        onClick={() => setHeroDot(i)}*/}
          {/*      />*/}
          {/*    ))}*/}
          {/*  </div>*/}
          {/*</div>*/}

          {/* Trust Bar */}
          <div className="ome__trust">
            {[
              {
                icon: <Icons.Truck />,
                title: "Free Delivery",
                sub: "On orders over $50",
              },
              {
                icon: <Icons.RefreshCw />,
                title: "Easy Returns",
                sub: "30-day returns",
              },
              {
                icon: <Icons.Shield />,
                title: "Secure Payment",
                sub: "100% protected",
              },
              {
                icon: <Icons.Headphones />,
                title: "24/7 Support",
                sub: "We're here to help",
              },
            ].map(({ icon, title, sub }) => (
              <div key={title} className="ome__trust-item">
                {icon}
                <div>
                  <strong>{title}</strong>
                  <span>{sub}</span>
                </div>
              </div>
            ))}
          </div>

          {/* Categories */}
          <section className="ome__categories">
            <SectionHeader title="Shop by Categories" />
            <div className="ome__cat-grid">
              {(categories.length
                ? categories.slice(0, 3)
                : [
                    {
                      cls: "electronics",
                      label: "Electronics",
                      desc: "Smartphones, Laptops, Audio & more",
                      img: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=280&q=80",
                    },
                    {
                      cls: "fashion",
                      label: "Fashion",
                      desc: "Men, Women & Kids Clothing",
                      img: "https://images.unsplash.com/photo-1551488831-00ddcb6c6bd3?w=280&q=80",
                    },
                    {
                      cls: "accessories",
                      label: "Accessories",
                      desc: "Watches, Bags, Sunglasses & more",
                      img: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=280&q=80",
                    },
                  ]
              ).map((c, idx) => {
                const cls = c.cls || c.key || `cat-${idx}`;
                const label =
                  c.category_name ||
                  c.name ||
                  c.label ||
                  c.category_label ||
                  "Category";
                const desc =
                  c.description || c.desc || "Shop products in this category";
                const img =
                  c.image_url ||
                  c.image ||
                  c.img ||
                  SUBCATS[idx % SUBCATS.length]?.img;

                return (
                  <div
                    key={label + idx}
                    className={`ome__cat-card ome__cat-card--${cls}`}
                  >
                    <span className="cat-tag">{label}</span>
                    <h3>{label}</h3>
                    <p>{desc}</p>
                    <button onClick={() => handleCategorySelect(c)}>
                      Shop Now <Icons.ChevronRight />
                    </button>
                    <img src={img} alt={label} loading="lazy" />
                  </div>
                );
              })}
            </div>
          </section>

          {/* Offer Cards */}
          <div className="ome__offers">
            {[
              {
                icon: "💳",
                iconCls: "green",
                title: "Bank Offer",
                desc: "Up to 10% Instant Discount on Credit Cards",
              },
              {
                icon: "💰",
                iconCls: "yellow",
                title: "No Cost EMI",
                desc: "Up to 12 Months No Cost EMI",
              },
              {
                icon: "🔄",
                iconCls: "purple",
                title: "Exchange Offer",
                desc: "Up to $100 Off on Exchange",
              },
            ].map(({ icon, iconCls, title, desc }) => (
              <div key={title} className="ome__offer-card">
                <div className={`icon icon--${iconCls}`}>{icon}</div>
                <div>
                  <h4>{title}</h4>
                  <p>{desc}</p>
                  <button>Shop Now</button>
                </div>
              </div>
            ))}
          </div>

          {/* Top Deals */}
          <section className="ome__products">
            <SectionHeader title="Top Deals" />
            <div className="ome__product-row">
              {(displayedProducts && displayedProducts.length > 0
                ? displayedProducts
                : TOP_DEALS
              ).map((p, idx) => (
                <ProductCard
                  key={p.id ?? idx}
                  product={p.id && p.price ? p : normalizeProduct(p, idx)}
                  showDisc
                />
              ))}
            </div>
          </section>

          {/* Dark Banner */}
          <div className="ome__dark-banner">
            <div className="ome__dark-banner-content">
              <h2>
                Big Savings on
                <br />
                Top Brands!
              </h2>
              <p>Limited time offers on bestsellers.</p>
              <button>
                Shop Now <Icons.ChevronRight />
              </button>
            </div>
            <div className="ome__dark-banner-badge">
              <span className="up">UP TO</span>
              <span className="pct">50%</span>
              <span className="off">OFF</span>
            </div>
            <div className="ome__dark-banner-img">
              <img
                src="https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&q=80"
                alt="Top brands"
              />
            </div>
          </div>

          {/* Best Sellers */}
          <section className="ome__products">
            <SectionHeader title="Best Sellers" />
            <div className="ome__product-row">
              {BEST_SELLERS.map((p) => (
                <ProductCard key={p.id} product={p} />
              ))}
            </div>
          </section>

          {/* New Arrivals */}
          <section className="ome__products">
            <SectionHeader title="New Arrivals" />
            <div className="ome__product-row">
              {NEW_ARRIVALS.map((p) => (
                <ProductCard key={p.id} product={p} isNew />
              ))}
            </div>
          </section>

          {/* Newsletter */}
          <div className="ome__newsletter">
            <div className="ome__newsletter-icon">
              <Icons.Mail />
            </div>
            <div className="ome__newsletter-text">
              <h3>Subscribe to our newsletter</h3>
              <p>
                Get the latest updates on new products and exclusive offers.
              </p>
            </div>
            <div className="ome__newsletter-form">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button>Subscribe</button>
            </div>
          </div>

          {/* Footer */}
          <footer className="ome__footer">
            <div className="ome__footer-grid">
              <div className="ome__footer-brand">
                <div className="logo">Ome</div>
                <p>Your one-stop destination for top brands and best deals.</p>
                <div className="ome__footer-socials">
                  {["f", "in", "tw", "yt"].map((s) => (
                    <a key={s} href="#">
                      {s}
                    </a>
                  ))}
                </div>
              </div>
              {[
                {
                  title: "Shop",
                  links: [
                    "All Products",
                    "Top Deals",
                    "New Arrivals",
                    "Best Sellers",
                    "Categories",
                  ],
                },
                {
                  title: "Customer Service",
                  links: [
                    "Contact Us",
                    "Track Your Order",
                    "Returns & Refunds",
                    "Shipping Info",
                    "FAQ",
                  ],
                },
                {
                  title: "Company",
                  links: [
                    "About Us",
                    "Careers",
                    "Blog",
                    "Privacy Policy",
                    "Terms & Conditions",
                  ],
                },
              ].map(({ title, links }) => (
                <div key={title} className="ome__footer-col">
                  <h4>{title}</h4>
                  <ul>
                    {links.map((l) => (
                      <li key={l}>
                        <a href="#">{l}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
              <div className="ome__footer-app">
                <h4>Download Our App</h4>
                <p>Get our app for exclusive offers and faster shopping.</p>
                <a href="#" className="ome__app-btn">
                  <Icons.Apple />
                  <div>
                    <span className="sub">Download on the</span>
                    <span className="name">App Store</span>
                  </div>
                </a>
                <a href="#" className="ome__app-btn">
                  <Icons.PlayStore />
                  <div>
                    <span className="sub">Get it on</span>
                    <span className="name">Google Play</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="ome__footer-bottom">
              <p>© 2024 Ome. All rights reserved.</p>
              <div className="ome__payment-icons">
                {["VISA", "MC", "AMEX", "Discover", "PayPal"].map((p) => (
                  <span key={p}>{p}</span>
                ))}
              </div>
            </div>
          </footer>
        </main>
      </div>

      {/* Back to Top */}
      <button
        className="ome__back-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <Icons.ChevronUp />
      </button>
    </div>
  );
}
